import { PortableTextBlock } from 'next-sanity'

import CustomPortableText from 'lib/sanity/richText/CustomPortableText'
import FormattedText from 'shared/ui/FormattedText'

import {
  SectionContainer,
  SectionContent,
  SectionTitle
} from '../landings/styles'

import styles from './HowPrepareReturn.module.scss'

interface HowPrepareReturnProps {
  header: string
  content: PortableTextBlock
}
const HowPrepareReturn = ({ header, content }: HowPrepareReturnProps) => {
  return (
    <SectionContainer $condensed className={styles.sectionContainer}>
      <SectionContent
        $top={10}
        $bottom={10}
        $topMobile={10}
        $bottomMobile={10}
        className={styles.sectionContent}
      >
        <div className={styles.maxWidthContainer}>
          <SectionTitle
            $center
            $size='3xl'
            $lineHeight={1.5}
            className={styles.sectionTitle}
          >
            <FormattedText text={header} />
          </SectionTitle>

          <CustomPortableText value={content || []} />
        </div>
      </SectionContent>
    </SectionContainer>
  )
}

export default HowPrepareReturn
